import type { Viewer } from '@crm/contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { SignOutButton } from '@/features/sign-out';
import { paths } from '@/shared/config';
import { Icon } from '@/shared/ui/icon';
import { ThemeSwitch } from '@/shared/ui/theme-switch';

import styles from './AppShell.module.scss';

interface ShellHeaderProps {
  viewer: Viewer;
  menuOpen: boolean;
  onOpenMenu: () => void;
}

function ProfileLink({ viewer }: { viewer: Viewer }): ReactElement {
  const name = `${viewer.firstName} ${viewer.lastName}`.trim() || viewer.email;
  const initials =
    [viewer.firstName, viewer.lastName].map((part) => part.charAt(0)).join('') ||
    viewer.email.charAt(0);
  return (
    <Link to={paths.profile} className={styles.profile} aria-label={name} title="Открыть профиль">
      <span className={styles.avatar} aria-hidden="true">
        {initials}
      </span>
      <span className={styles.profileName}>{name}</span>
    </Link>
  );
}

export function ShellHeader({ viewer, menuOpen, onOpenMenu }: ShellHeaderProps): ReactElement {
  return (
    <header className={styles.topbar}>
      <button
        type="button"
        className={styles.menuButton}
        aria-label="Открыть меню"
        aria-expanded={menuOpen}
        aria-haspopup="dialog"
        onClick={onOpenMenu}
      >
        <Icon name="menu" />
      </button>
      <span className={styles.workspace}>Рабочее пространство</span>
      <div className={styles.user}>
        <ThemeSwitch />
        <ProfileLink viewer={viewer} />
        <SignOutButton />
      </div>
    </header>
  );
}
